export const ES: Record<string, string> = {
  "Recommended for you": "Recomendado para ti",
  "Resource added to favorite": "Recurso añadido a favoritos",
  "Failed to add resource to favorite": "Error al añadir recurso a favoritos",
  "Resource removed from favorite": "Recurso eliminado de favoritos",
  "Failed to remove resource from favorite": "Error al eliminar recurso de favoritos",
  "Calendar": "Calendario",
  "View Detail": "Ver detalles",
  "Add to favorites": "Añadir a favoritos",
  "Remove from favorites": "Eliminar de favoritos",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Descripción: Sala de reuniones VIP con una vista espectacular y sillas cómodas.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "No hay recursos disponibles a la hora elegida en su ubicación o en sus favoritos.",
  "You have these options:": "Tiene estas opciones:",
  "Change the meeting time.": "Cambiar la hora de la reunión.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Use el botón <1>Buscar hora disponible</1> para elegir una nueva hora.",
  "Open the search to find other resources.": "Abra la búsqueda para encontrar otros recursos.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "El tipo de recurso <1>'{{resourceType}}'</1> no existe en su ubicación predeterminada",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "El tipo de recurso <1>'{{resourceType}}'</1> puede encontrarse en una ubicación diferente.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Haga clic aquí</1> para agregar el tipo de recurso a su configuración de ubicación predeterminada.",
  
  // ResourceCard
  "New Order": "Nuevo pedido",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Al reservar un recurso agrupado, solo se puede reservar este tipo de recurso y solo uno.",
  "You cannot select both a child resource and its virtual resource at the same time.": "No puede seleccionar tanto un recurso hijo como su recurso virtual al mismo tiempo.",
  // Settings
  "Note:": "Nota:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Un organizador asistente puede recibir los mismos correos electrónicos de Resource Central que el organizador y puede gestionar pedidos en nombre del organizador.",
  "Setting updated successfully": "Configuración actualizada correctamente",
  "Setting updated failed": "Error al actualizar la configuración",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 espacio",
  "Opening hours:": "Horario de apertura:",
  "Buffer time {{minutes}} mins between reservations": "Tiempo de buffer {{minutes}} min entre reservas",
  "Initial payment {{value}} pr.minute": "Pago inicial {{value}} por minuto",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Total {{total}} asistentes",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} de {{total}} internos pueden asistir.",
  "{{external}} external is unknown.": "{{external}} externos son desconocidos.",
  "Find available time": "Buscar hora disponible",
  "Attendees": "Asistentes",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Haga clic en Más información para visitar nuestro sitio de soporte",
  "Further information": "Más información",
  
  // LocationSetting
  "Location changed": "Ubicación cambiada",
  "Location change failed": "Error al cambiar la ubicación",
  "Please select at least one location": "Seleccione al menos una ubicación",
  "Resource types": "Tipos de recursos",
  "Location": "Ubicación",
  "Where": "Dónde",
  
  // ModalShowAttendees
  "Total": "Total",
  "Available": "Disponible",
  "Busy": "Ocupado",
  "External": "Externo",
  "Internal": "Interno",
  
  // ResourceSearch
  "Search by resource name": "Buscar por nombre de recurso",
  "Category": "Categoría",
  "Filter by Location": "Filtrar por ubicación",
  "Filter by Category": "Filtrar por categoría",
  "Capacity": "Capacidad",
  "Filter by Capacity": "Filtrar por capacidad",
  "All": "Todos",
  "Filter by availability": "Filtrar por disponibilidad",
  "Sort By": "Ordenar por",
  "Loading...": "Cargando...",
  
  // SelectedResources
  "Meeting Type": "Tipo de reunión",
  "Meeting Label": "Etiqueta de reunión",
  
  // Alert (accessibility text)
  "Check icon": "Icono de verificación",
  "Close": "Cerrar",
  
  // AppConstants - searchTab
  "Resource": "Recurso",
  "Person": "Persona",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "¿Dónde suelen realizarse sus reuniones?",
  "To improve our recommendations for you we would like you to enter your normal location": "Para mejorar nuestras recomendaciones para usted, nos gustaría que ingrese su ubicación habitual",
  "What do you use most?": "¿Qué usa más?",
  "To enable quicker and better search please chose you prefered resource type": "Para permitir una búsqueda más rápida y mejor, elija su tipo de recurso preferido",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Haga clic en el recurso para seleccionar",
  "Selected Resources": "Recursos seleccionados",
  "Setting": "Configuración",
  "Search": "Buscar",
  "Find Colleague": "Buscar colega",
  "Quick button setting": "Configuración de botón rápido",
  "Favorite": "Favorito",
  "Most Used": "Más usados",
  "Colleagues": "Colegas",
  "Resources": "Recursos",
  
  // AppConstants - tooltipText
  "Back": "Atrás",
  "Floor Plan": "Plano de planta",
  "Expand": "Expandir",
  "Selected resources": "Recursos seleccionados",
  "View details": "Ver detalles",
  "Remove from My Favorites": "Eliminar de mis favoritos",
  "Add to My Favorites": "Añadir a mis favoritos",
  "Remove": "Eliminar",
  "Favorite - Most Used": "Favorito - Más usados",
  "Conflict": "Conflicto",
  "Approved": "Aprobado",
  "Recommendeded for you": "Recomendado para ti",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Solo organizador principal",
  "Only assistant organizer": "Solo organizador asistente",
  "Primary AND assistant organizer": "Organizador principal Y asistente",
  
  // FindColleague
  "Enter colleague name": "Ingrese el nombre del colega",
  "Recent work items": "Elementos de trabajo recientes",
  "No data available": "No hay datos disponibles",
  "Floorplan": "Plano de planta",
  "List nearby resources": "Lista de recursos cercanos",
  "Find resource nearby": "Buscar recurso cercano",
  "No Resources available": "No hay recursos disponibles",
  
  // Start page
  "Next": "Siguiente",
  "Failed to update default locations": "Error al actualizar las ubicaciones predeterminadas",
  "Resource Type": "Tipo de recurso",
  
  // QuickSetting
  "Quick buttons updated successfully": "Botones rápidos actualizados correctamente",
  "Quick buttons updated failed": "Error al actualizar los botones rápidos",
  "Add more": "Agregar más",
  "Apply": "Aplicar",
  "Delete": "Eliminar",
  "Name": "Nombre",
  "Enter name": "Ingrese el nombre",
  "Tooltip": "Información sobre herramientas",
  "Enter tooltip": "Ingrese información sobre herramientas",
  "Type": "Tipo",
  "Select type": "Seleccione el tipo",
  "Locations": "Ubicaciones",
  "Select colleagues": "Seleccionar colegas",
  "Select resources": "Seleccionar recursos",
  
  // DefaultResourceSetting
  "Resource type changed": "Tipo de recurso cambiado",
  "Resource type change failed": "Error al cambiar el tipo de recurso",
  "Default Resource Type": "Tipo de recurso predeterminado",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Aplicado correctamente",
  "Apply Failed": "Error al aplicar",
  "Assistant Organizer": "Organizador asistente",
  "Enter a part of the name to search for": "Ingrese parte del nombre para buscar",
  "Mail Flow": "Flujo de correo",
  "Select Mail Flow": "Seleccionar flujo de correo",
  
  // TileConfigurationSetting
  "Update settings successfully": "Configuración actualizada correctamente",
  "Update settings failed": "Error al actualizar la configuración",
  "Timeline": "Línea de tiempo",
  
  // SelectCategoryForm
  "And": "Y",
  "Or": "O",
  
  // Other
  "Resource Calendar": "Calendario de recursos",
  
  // SettingLabels
  "Default Location": "Ubicación predeterminada",
  "Quick button": "Botón rápido",
  "Category icons": "Iconos de categoría",
  "Recommendation screen": "Pantalla de recomendaciones",
  "Capacity filter": "Filtro de capacidad",
  "AI Assistant": "Asistente de IA",
  "Tile configuration": "Configuración de mosaicos",
  "Help": "Ayuda",
  "Default Categories": "Categorías predeterminadas",
  
  // MeetingType
  "Your must select a Meeting label": "Debe seleccionar una etiqueta de reunión",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Recurso seleccionado: 'AOD_Copanhagen' Ocurrencias conflictivas",
  "Alternative Resource": "Recurso alternativo",
  "OK": "OK",
  "Cancel": "Cancelar",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Su recurso seleccionado 'AOD_Copenhagen' fue eliminado",
  "You can't book this resource as your request exceeds the available capacity.": "No puede reservar este recurso porque su solicitud excede la capacidad disponible.",
  
  // ChangeTime
  "Time changed successfully": "Hora cambiada correctamente",
  "Current Time": "Hora actual",
  "Suggested Times": "Horas sugeridas",
  "Change Time": "Cambiar hora",
  "people are free": "personas están libres",
};

